import { useEffect, useState } from 'react';

// Matches Tailwind's `md` breakpoint: below 768px the mobile shell is used
const MOBILE_QUERY = '(max-width: 767px)';

export function isMobileViewport() {
  return typeof window !== 'undefined' && window.matchMedia(MOBILE_QUERY).matches;
}

/**
 * True when the viewport is narrower than the `md` breakpoint.
 * Re-renders when the viewport crosses the breakpoint.
 */
function useIsMobile() {
  const [isMobile, setIsMobile] = useState(isMobileViewport);

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}

export default useIsMobile;
